import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

export const NoVisibleChangesHint = () => {
  const { t } = useTranslation();

  return (
    <div className="pointer-events-none absolute bottom-3 left-1/2 z-10 flex max-w-[90%] -translate-x-1/2 items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 shadow-sm">
      <AlertTriangle size={14} className="mt-0.5 shrink-0 text-amber-600" />
      <span>{t("smartSurveyor.planComparison.visual.noVisibleChanges")}</span>
    </div>
  );
};
